import HeadHtml from '@src/components/layout/HeadHtml'
import { Button, Checkbox, Col, Form, Input, Row } from 'antd'
import logoApp from '@assets/favicon.svg'
import { LockOutlined, PhoneOutlined } from '@ant-design/icons'
import { TSignIn } from '@src/modules'
import { checkAuth } from '@src/libs/localStorage'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutationSignIn } from '@src/queries/hooks'
import { regexPhoneNumber } from '@src/utils/regex'

function Login() {
  const [form] = Form.useForm<TSignIn>()
  const navigate = useNavigate()
  const token: string = checkAuth()

  const { mutate, isLoading } = useMutationSignIn()
  const onLogin = (values: TSignIn) => {
    mutate(values, {
      onSuccess: () => {
        navigate('/')
      },
    })
  }

  useEffect(() => {
    if (token) navigate('/')
  }, [navigate, token])
  return (
    <Row className="login-container">
      <HeadHtml title="Login" />
      <Col className="login-boxer">
        <Row gutter={[24, 60]} align="middle" justify="center">
          <Col span={24}>
            <Row justify="center">
              <img src={logoApp} className="logo" alt="logo" />
            </Row>
          </Col>
          <Col span={24}>
            <Form name="login" form={form} onFinish={onLogin}>
              <Form.Item
                name="phone"
                rules={[
                  { required: true, message: 'Please input your phone number!' },
                  { pattern: regexPhoneNumber, message: 'Phone number invalid!' },
                ]}
              >
                <Input
                  prefix={<PhoneOutlined />}
                  placeholder="Phone number"
                  size="large"
                  autoFocus
                  onPressEnter={() => form.submit()}
                />
              </Form.Item>

              <Form.Item name="password" rules={[{ required: true, message: 'Please input your Password!' }]}>
                <Input.Password
                  prefix={<LockOutlined />}
                  type="password"
                  placeholder="Password"
                  size="large"
                  onPressEnter={() => form.submit()}
                />
              </Form.Item>

              <Form.Item>
                <Form.Item valuePropName="checked" noStyle>
                  <Checkbox style={{ color: '#ffffff' }} checked>
                    Remember me
                  </Checkbox>
                </Form.Item>
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn-submit-login"
                  size="large"
                  block
                  loading={isLoading}
                  disabled={isLoading}
                >
                  LOGIN
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Login
